import { FeedRounded, Menu, MenuOpen } from '@mui/icons-material';
import {
  Box,
  Divider,
  IconButton,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuButton from './MenuButton';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNotifiche } from '../redux/notifiche/operations';
import { brand, gray } from '../theme/themePrimitives';
import {
  toggleDrawerNotifiche,
  toggleDrawerComunicazioni,
  toggleSideMenu,
} from '../redux/app/slice';
import { getComunicazioni } from '../redux/comunicazioni/operations';
import { ReactComponent as NotificheIconSvg } from '../assets/img/notifiche_icon.svg';

export default function Header({ forceShow = false, height = 50 }) {
  const dispatch = useDispatch();
  const { notifiche } = useSelector(state => state.notifiche);
  const { comunicazioni } = useSelector(state => state.comunicazioni);
  const { drawerNotificheOpen, drawerComunicazioniOpen, sideMenuOpen } =
    useSelector(state => state.app);

  const theme = useTheme();
  const matchMd = useMediaQuery(theme.breakpoints.up('md'));

  const notificheNonLette = notifiche.filter(n => n.data_lettura == null);

  useEffect(() => {
    dispatch(getNotifiche());
    dispatch(getComunicazioni());
  }, []);

  const onToggleDrawerNotifiche = e => {
    e.preventDefault();
    dispatch(toggleDrawerNotifiche());
  };

  const onToggleDrawerComunicazioni = e => {
    e.preventDefault();
    dispatch(toggleDrawerComunicazioni());
  };

  const onMenuToggle = () => {
    dispatch(toggleSideMenu());
  };

  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: forceShow ? 'flex' : 'none', md: 'flex' },
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        pl: 1,
      }}
      spacing={2}
    >
      {matchMd ? (
        <IconButton
          sx={{
            border: 'none',
            borderRadius: '100%',
            width: '30px',
            height: '30px',
          }}
          onClick={onMenuToggle}
        >
          {sideMenuOpen ? (
            <MenuOpen sx={{ color: gray[500] }} />
          ) : (
            <Menu sx={{ color: gray[500] }} />
          )}
        </IconButton>
      ) : (
        <> </>
      )}

      <Box
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'row',
          height: height,
          pr: 4,
        }}
      >
        <Box
          sx={{
            justifyContent: 'space-between',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <MenuButton
            varian="icon"
            color="primary"
            sx={{
              m: 0.5,
              border: 'none',
              backgroundColor: 'primary.dark',
              color: 'white',
              borderRadius: '100%',
              width: '30px',
              height: '30px',
              '&:hover': {
                backgroundColor: brand[800],
              },
              '&:active': {
                backgroundColor: brand[900],
              },
            }}
            showBadge={comunicazioni.length > 0}
            badgeContent={comunicazioni.length}
            aria-label="Open notifications"
            onClick={onToggleDrawerComunicazioni}
          >
            <FeedRounded />
          </MenuButton>
          <Divider
            sx={{
              visibility: drawerComunicazioniOpen ? 'visible' : 'hidden',
              height: '3px',
              width: '20px',
              borderRadius: '4px',
              alignSelf: 'center',
              backgroundColor: 'primary.dark',
            }}
          />
        </Box>

        <Box
          sx={{
            justifyContent: 'space-between',
            display: 'flex',
            flexDirection: 'column',
            ml: 2,
          }}
        >
          <MenuButton
            varian="icon"
            color="primary"
            sx={{
              m: 0.5,
              border: 'none',
              backgroundColor: 'primary.dark',
              color: 'white',
              borderRadius: '100%',
              width: '30px',
              height: '30px',
              '&:hover': {
                backgroundColor: brand[800],
              },
              '&:active': {
                backgroundColor: brand[900],
              },
            }}
            showBadge={notificheNonLette.length > 0}
            badgeContent={notificheNonLette.length}
            aria-label="Open notifications"
            onClick={onToggleDrawerNotifiche}
          >
            <NotificheIconSvg />
          </MenuButton>
          <Divider
            sx={{
              visibility: drawerNotificheOpen ? 'visible' : 'hidden',
              height: '3px',
              width: '20px',
              borderRadius: '4px',
              alignSelf: 'center',
              backgroundColor: 'primary.dark',
            }}
          />
        </Box>
      </Box>
    </Stack>
  );
}
